module.exports = __webpack_public_path__ + "images/calendar-icon-white.svg";